module.exports = __webpack_public_path__ + "media/images/expodom_logo_hungary_version-857cc511f189ab5ac5f709699c0a1a65.png";